import { observer } from "mobx-react";
import Drawer from "../../../../../components/drawer/drawer";
import RefundCalculatorDrawerHeader from "./refund-calculator-drawer-header/refund-calculator-drawer-header";
import "./refund-calculator-drawer.scss";
import RefundCalculatorDrawerContent from "./refund-calculator-drawer-content/refund-calculator-drawer-content";
import RmaPageStore from "../../stores/rma-page-store";
import rmsMixpanelStore from "../../../../../stores/rms-mixpanel-store";

interface IRefundCalculatorDrawerProps{
    closeAction: ()=>void;
    rma: RmaPageStore;
}

const RefundCalculatorDrawer: React.FC<IRefundCalculatorDrawerProps> = observer(({closeAction, rma}) => {
    const calculatorStore = rma.refundCalculatorStore;

    if (!calculatorStore) {
        return null;
    }
    
    return(
        <>
            <Drawer 
                closeButton={{onClick:()=> {
                    rmsMixpanelStore.trackEvent('d&_calculator_close', { RMAID: rma.rmaId });
                    closeAction();
                }
                }}
            >
                <div className="refund-calculator-drawer">
                    <RefundCalculatorDrawerHeader calculatorStore={calculatorStore}/>
                    <RefundCalculatorDrawerContent 
                        calculatorStore={calculatorStore} 
                        onCancelClick={() => closeAction()}
                        rma={rma}
                    />
                </div>
            </Drawer>
    </>
)

});

export default RefundCalculatorDrawer;